import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/root';
import { resetFilters } from '../../../../../redux/slices/filterSlice';

type Props = {
  label: string;
};

const BannerStrip: FC<Props> = ({ label, children }) => {
  const dispatch = useDispatch();
  const filters = useSelector((s: RootState) => s.filters.filters);

  useEffect(() => {
    if (filters.length > 0) {
      dispatch(resetFilters());
    }
  }, []);

  return (
    <Bar>
      <Title>{label}</Title>
      {children && <Tools>{children}</Tools>}
    </Bar>
  );
};

export default BannerStrip;

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 56px;
  padding: 0 20px;
  margin-bottom: 16px;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif;

  @media only screen and (max-width: 540px) {
    height: auto;
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 10px;
  }
`;

const Title = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-600);

  @media only screen and (max-width: 540px) {
    font-size: 0.6875rem;
  }
`;

const Tools = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;
